import { Box, Group, Text, Button, Badge } from '@mantine/core'
import { IconEye, IconX } from '@tabler/icons-react'
import { useAuthStore } from '@/store/auth'
import { useNavigate } from 'react-router-dom'

export function PreviewBanner() {
  const { previewTemplate, exitPreview } = useAuthStore()
  const navigate = useNavigate()

  if (!previewTemplate) return null

  const handleExit = () => {
    exitPreview()
    navigate('/')
  }

  return (
    <Box
      style={{
        backgroundColor: '#e67700',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 200,
        flexShrink: 0,
      }}
    >
      <Group gap="sm">
        <IconEye size={16} color="white" />
        <Text size="sm" fw={600} c="white">
          Modo prévia ativo
        </Text>
        <Badge color="orange" variant="filled" size="sm" style={{ backgroundColor: 'rgba(255,255,255,0.25)', color: 'white' }}>
          {previewTemplate.name}
        </Badge>
        <Text size="xs" c="white" style={{ opacity: 0.85 }}>
          Você está visualizando o sistema como este perfil. Nenhuma alteração foi feita.
        </Text>
      </Group>
      <Button
        size="xs"
        variant="white"
        color="orange"
        leftSection={<IconX size={13} />}
        onClick={handleExit}
      >
        Sair do modo prévia
      </Button>
    </Box>
  )
}
